var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83337 6.91667C1.83337 3.25 2.75004 2.33334 6.41671 2.33334H7.79171C9.16671 2.33334 9.46923 2.73668 9.99173 3.43335L11.3667 5.26668C11.7151 5.72501 11.9167 6 12.8334 6H15.5834C19.25 6 20.1667 6.91667 20.1667 10.5833V12.4167",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25004 20.6667H6.41671C2.75004 20.6667 1.83337 19.75 1.83337 16.0833V11.5275",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6133 17.2934C10.4591 17.4492 10.4591 20.5658 12.6133 20.7217H17.71C18.3241 20.7217 18.9291 20.4925 19.3783 20.08C20.8908 18.76 20.0841 16.12 18.095 15.8725C17.38 11.5733 11.165 13.205 12.6317 17.3025",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminWhite);
export default __webpack_public_path__ + "static/media/adminWhite.062aaabc7be508567957d7707e3fcfcc.svg";
export { ForwardRef as ReactComponent };